 import React from "react"
 import {Form, Icon, Button, Label, Grid, Container} from "semantic-ui-react";
 import {getProfessions} from "../../../Api/Api";
 import ProgressContainer from "../../Progress/ProgressContainer";

const section = (props) => {
    return (

        props.team.staff.map((val, index)=> {
            let disabled = false;
            let allow_quantity = false;
            if (props.team.staff.length < 2) disabled = true;
            if (!props.team.staff[index].position_id) allow_quantity = true;

            return (
                <Form className={'position'}>
                    <Form.Group>
                        <Form.Dropdown
                            width={9}
                            options={props.team.list}
                            placeholder='Choose position...'
                            dataId={index}
                            name={"positions"}
                            selection
                            search
                            value={props.team.staff[index].position_id}
                            closeOnBlur={false}
                            onChange={props.setPosition}
                        />
                        <div className={'qbuttons'}>
                            <Label className={'count'} size={'large'}>
                                <Icon name='user' /> {props.team.staff[index].quantity}
                            </Label>
                            <Button disabled={allow_quantity} circular icon='plus' color={'white'} onClick={()=>{props.changeQuantity(index, 1)}} />
                            <Button disabled={allow_quantity} circular icon='minus' onClick={()=>{props.changeQuantity(index, 0)}} />
                            <Button className={'remove'} disabled={disabled} icon='trash' onClick={()=>{props.delPosition(index)}} content='Remove'/>
                        </div>
                    </Form.Group>
                </Form>
            )
        })
    )
}

 class Team extends React.Component {

     constructor(props) {
         super(props);
     }

     componentDidMount() {
         if (this.props.flow.targetID) {
             getProfessions(this.props.flow.targetID).then(data => {
                 if(data.staff){
                     this.props.updatePositionsList(data.staff);
                 }
             });
         }
         this.props.scrollToStep(4);
     }

     render() {
         let disabled = false;
         if (!this.props.team.staff[0].position_id) {
             disabled = true;
         }

         return (
             <Grid id={'team'} className={'step-section'}>
                 <Grid.Row>
                     <Container className={"pre-header"}>
                         <h2>IT Team Cost Calculator</h2>
                         <h4>With Intersog, you get access to <strong>250+</strong> top software developers ready to commit from day one.</h4>
                     </Container>
                     <ProgressContainer/>
                     <Container className={"team"}>
                         <h3>What skills do you need?</h3>
                         {section(this.props)}
                     </Container>
                     <Container className={"navigation"}>
                         <Button floated={'left'} color={'blue'} icon labelPosition='left' className={`add-position`} onClick={this.props.addItem}>
                             Add Position
                             <Icon name='user plus'/>
                         </Button>
                     </Container>
                     <Container className={"navigation"}>
                         <Button className={`intersog-btn left inverse`} onClick={() =>{this.props.scrollToStep(3);}}>
                             Back
                         </Button>
                         <Button className={`intersog-btn right`} onClick={() =>{this.props.setNextStep(6);this.props.changeStep();this.props.scrollToStep(6);}} disabled={disabled}>
                             Next
                         </Button>
                     </Container>
                 </Grid.Row>
             </Grid>
         );
     }
 }

 export default Team